import Carousel from '@reusable-modules/Carousel'
import LazyComponent from '@components/LazyComponent'

const CarouselComponent = (props) =>
  <LazyComponent id={props.id}><Carousel {...props} /></LazyComponent>

export default CarouselComponent